export enum ConsultationStorageKeys {
  Address = 'address',
  BmiScore = 'bmi_score',
  ConsultationAdditionalInfo = 'consultation_additional_info',
  ConsultationId = 'consultation_id',
  ConsultationStatus = 'consultation_status',
  CreateAttachmentToken = 'create_attachment_token',
  CustomerTests = 'customerTests',
  Hash = 'hash',
  IdAttachmentUploaded = 'id_attachment_uploaded',
  Lab = 'lab',
  OrderedTests = 'orderedTests',
  PartnerEmail = 'partnerEmail',
  Patient = 'patient',
  Pharmacy = 'pharmacy',
  Questionnaire = 'questionnaire',
  QuestionnaireMedicalHistory = 'questionnaire-medicalHistory',
  Recharge = 'recharge',
  RemainingBalance = 'remaining_balance',
  ScheduleOnceId = 'schedule_once_id',
  ShippingAddress = 'shippingAddress',
  ShippingAddressId = 'shippingAddressId',
  TransactionId = 'transaction_id',
  TreatmentFor = 'treatment_for',
  TreatmentPreferenceTests = 'treatmentPreferenceTests',
  TreatmentPreferences = 'treatmentPreferences',
  TreatmentType = 'treatmentType',
  UpsellAddress = 'upsell_address',
  UpsellTransactionId = 'upsell_transaction_id',
  UpsellUpgrades = 'upsell-upgrades',
  Upsells = 'upsells',
  HasMandatoryLabResult = 'hasMandatoryLabResult',
}
